<template>

    <div>

            <div class="text-wrapper frame " :style="{'padding': $mq === 'phone' ? '0rem' : '2rem'}"> 

                <div class="text" :style="{'visibility': visibility}">
                    
                   <p style="font-style: italic">

                      {{text.p1}}

                   </p> 

                    <p>
                        
                        {{text.p2}}

                   </p> 

                   <p>
                        
                         <span class="link"> {{text.l1}} </span>

                   <br>

                         <span @click="newWindow('https://www.coronaindestad.nl/marieke-zwart-the-river-2020-nl/')" class="link"> {{text.l2}} </span>

                   </p>

                   <p>

                       <br>

                       <span style="font-weight: bold"> {{ text.f1 }} </span> 

                       <br><br>

                       <span style="font-weight: bold"> {{ text.f2 }} </span> 

                       <br>

                       <span> {{ text.f3 }} </span> 

                        <br>

                       <span> {{ text.f4 }} </span> 

                        <br>

                       <span> {{ text.f5 }} </span> 

                        <br>

                       <span> {{ text.f6 }} </span> 

                        <br><br>

                       <span @click="newWindow('https://www.voordekunst.nl/projecten/10460-de-rivier')" class="link"> {{ text.f7 }} </span> 

                        <br><br>

                       <a @click="newWindow('https://www.mariekezwart.nl')" class="link" style="font-weight: bold"> {{ text.f8 }} </a> 

                   </p>
                
                </div>

            </div>
    </div>

  
</template>

<script>
import { EventBus } from '../events/eventbus';

export default {
    data: () => {
        return {
            toggled: false,
            visibility: 'visible',
            text: {
                p1: '',
                p2: ''
            },
            dutchText: {
                p1: "De eerste (houten) huizen op de Nieuwendijk werden gebouwd rond 1225. Ze waren de oudste woonhuizen van Amsterdam. Ik woon nu meer dan 10 jaar boven de archeologische resten op de eerste verdieping aan de Nieuwendijk. Heel lang was er onder mijn raam een rivier van mensen. Tot maart 2020, toen liep er wekenlang niemand meer vanwege Covid-19. In mijn hoofd is er toen een echte rivier ontstaan.",
                p2: "Mijn film DE RIVIER duurt ruim 10 minuten. Ongeveer zo lang als een wandeling van het begin van de Nieuwendijk, aan de Singel, naar het einde op de Dam. Je kunt de film bekijken terwijl je deze wandeling maakt op je telefoon met een hoofdtelefoon. Kijk dan ook goed om je heen, naar de mensen en de gevels. Thuis en op tentoonstellingen is de film tevens het beste te ervaren met een hoofdtelefoon.",
                l1: "De Rivier op AT5",
                l2: "De Rivier in het Amsterdams Historisch Museum",
                f1: "DE RIVIER, 2020",
                f2: "HD Stereo sound",
                f3: "10:15 sec",
                f4: "(verticaal scherm)",
                f5: "Geluid Vincent de Bel en Marieke Zwart",
                f6: "Ondertitels Laura O’Neill en Marieke Zwart",
                f7: "Met dank aan alle donaties",
                f8: "www.mariekezwart.nl"
            },
            englishText: {
                p1: "The first (wooden) houses at the Nieuwendijk were built around 1225. They were the oldest residential houses of Amsterdam (NL). I have been living on the remains for over ten years now on the first floor. For a long time there ran a river of people underneath my windows. Untill Covid-19, March 2020. The street had never been as desolate as it is was then. In my head an actual river appeared.",
                p2: "My film lasts about 10 minutes. About the same time a walk takes from the beginning of the Nieuwendijk, at the Singel, up to the end at Dam Square. You are invited to watch the sequence on your phone (with headphones) while making this walk. Do look around you, mind people and facades. At home and in exhibitions the film is also experienced best via headphones.",
                l1: "De Rivier op AT5",
                l2: "De Rivier in het Amsterdams Historisch Museum",
                f1: "DE RIVIER, 2020",
                f2: "HD Stereo sound",
                f3: "10:15 sec",
                f4: "(for vertical screens)",
                f5: "Sound Vincent de Bel and Marieke Zwart",
                f6: "Subtitles Laura O’Neill and Marieke Zwart",
                f7: "Thanks to all donations",
                f8: "www.mariekezwart.nl"
            },
        }
    },
    created() {
        this.text = {...this.dutchText},
        EventBus.$on('language', (language) => {
            language === 'ENGLISH' ? this.text = {...this.englishText} : this.text = {...this.dutchText};
        })
    }
}
</script>

<style scoped lang="scss">

@import 'main.scss';


.text-wrapper {
    width: 100%;
    
    display: flex;
    justify-content: center;
    align-items: flex-start;

     @media only screen and (max-width: 700px) {
           align-items: center;
    }
}

.text {
    font-size: 1.6rem;
    letter-spacing: 0;
    text-transform: none;
    max-width: 75rem;
}

</style>